module.exports = __webpack_public_path__ + "media/images/sme-thankyou-a458178a309bcda952344f7c8a068d0d.png";